module.exports = __webpack_public_path__ + "media/1-e.d6fe7d89.wav";